import React, {PureComponent} from 'react';
import I18n from 'app/i18n';
import type {CasinoFilterInterface, PageElementCasinoGameInterface} from 'app/interfaces/stores/CasinoGamesStoreInterfaces';
import CasinoGameItem from '../CasinoGameItem';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface CasinoNewReleaseBlockProps {
    game: PageElementCasinoGameInterface
    activeClickGame?: number | null
    cool_off_present?: boolean
    deactivateGame?: () => void
    filter?: CasinoFilterInterface
    isGameOfTheWeek?: boolean
    setActiveGame?: (id: number) => void
    style?: React.CSSProperties
}

export default class CasinoNewReleaseBlock extends PureComponent<CasinoNewReleaseBlockProps> {
    render(): React.ReactNode {
        const {game} = this.props;

        if (!game) {
            return null;
        }

        const {
            filter,
            setActiveGame,
            activeClickGame,
            deactivateGame,
            cool_off_present,
            isGameOfTheWeek,
            style
        } = this.props;
        const isActiveGame = activeClickGame === game.id;

        const blockClassName = [
            'casino-new-release-block',
            'medium-marketing-block',
            'marketing-block',
            isGameOfTheWeek && 'casino-new-release-block_game-of-the-week'
        ].filter(Boolean).join(' ');

        return (
            <div
                className={blockClassName}
                style={style}
            >
                <div className="casino-new-release-block__header">
                    <SpriteIcon name={isGameOfTheWeek ? '#svg-cup-table' : '#svg-new-release'}
                        className="svg-default casino-new-release-block__new-icon"/>
                    <span className="casino-new-release-block__title">
                        {I18n.t(isGameOfTheWeek ? 'game_of_the_week' : 'new_release')}
                    </span>
                </div>
                <CasinoGameItem
                    key={`casinoGame-new-release-${game.id}`}
                    active={isActiveGame}
                    setActiveGame={setActiveGame}
                    deactivateGame={deactivateGame}
                    cool_off_present={cool_off_present}
                    filter={filter}
                    useStartCasino
                    {...game}
                />
            </div>
        );
    }
}
